import React, { useMemo } from 'react';
import { DataTable } from '@/Components/DataTable/DataTable';
import { useEmailTemplatesTableColumnInfo } from './ColumnInfo';
import { useDispatch, useSelector } from 'react-redux';
import { emailSendModalActions } from '../../services/reducer';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';

export const SelectTemplateTable = (): React.ReactElement => {
  const dispatch = useDispatch();

  const columnInfos = useEmailTemplatesTableColumnInfo();
  const emailTemplates = useSelector(emailSendModalSelectors.rows);

  return useMemo(() => {
    return (
      <DataTable
        rowKey={'guid'}
        rows={emailTemplates}
        columnInfos={columnInfos}
        filterOptions={{
          needGlobalSearchPanel: false,
          needColumnChooser: false,
          needClearFiltersButton: false,
          needShowFiltersButton: false,
          needHeaderFilter: false,
          needSearchFilterRow: false,
          showFilterBuilder: false,
        }}
        exportOptions={{
          exportFileName: '',
          needExport: false,
        }}
        selectOptions={{
          onFocusedRowChanged: (data) => {
            if (data) {
              dispatch(emailSendModalActions.setDocumentType(data?.numberGenerationType));
              dispatch(emailSendModalActions.setSelectedEmailTemplate(data));
            }
          },
        }}
      />
    );
  }, [emailTemplates, columnInfos]);
};
